import { ChangeDetectionStrategy, Component, Injector, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
  NumberSpinnerComponent,
  SpinType,
} from "shared/base-components/number-spinner.component";
import { SpinDirection } from "shared/base-components/spinner-buttons.component";
import { BfxFieldNumberDirective } from "../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../shared/base-components/bfx-input";

export const AMOUNT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxTemperatureSpinnerComponent),
  multi: true,
};

/**
 * A percentage-style spinner that supports positive and negative numbers.
 * When the precision of the entered number is 2, the spin value is 0.01, otherwise
 * the spin value is 1
 */
@Component({
  selector: "bfx-temperature-spinner",
  templateUrl: "../../shared/base-components/html/number-spinner.html",
  providers: [AMOUNT_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxTemperatureSpinnerComponent extends NumberSpinnerComponent {
  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
  ) {
    super(injector, inputDirective, fieldDirective);

    this.minPrecision = 2;
    this.maxPrecision = 2;
    this.spinType = SpinType.EXTERNAL;
    this.externalStepHandler = this.intOrDecSpinHandler.bind(this);
    this.mandatory = true;

    this.fieldSuffix = "%";
  }

  /**
   * External stepper function that provides an int or dec step value
   * @param value
   * @param direction
   * @returns
   */
  protected intOrDecSpinHandler(value: BigNumber, direction: SpinDirection): BigNumber {
    let retStep: BigNumber;

    if (value) {
      if (value.decimalPlaces() == 0) {
        retStep = new BigNumber("1");
      } else {
        retStep = new BigNumber("0.01");
      }
    } else {
      if (this.config.maxPrecision == 0) {
        retStep = new BigNumber("1");
      } else {
        retStep = new BigNumber("0.01");
      }
    }
    if (direction == SpinDirection.DOWN) {
      retStep = retStep.negated();
    }
    return retStep;
  }
}
